const ISO_REGEXP =
  /P(?:(\d+)Y)?(?:(\d+)M)?(?:(\d+)W)?(?:(\d+)D)?T?(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?/;

export interface Duration {
  years: number;
  months: number;
  weeks: number;
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
}

function toInt(value: string): number {
  return parseInt(value, 10) || 0;
}

export function parse(isoString: string): Duration {
  const matches = String(isoString).match(ISO_REGEXP) || [];
  const [, ...data] = matches; // [, ...data] : The "," is to skip the first element of the array

  const [years = 0, months = 0, weeks = 0, days = 0, hours = 0, minutes = 0, seconds = 0] =
    data.map(toInt);

  return {
    years,
    months,
    weeks,
    days,
    hours,
    minutes,
    seconds,
  };
}

export function toSecond(isoStringParsed: Duration): number {
  const { years, months, weeks, days, hours, minutes, seconds } = isoStringParsed;

  if (years > 0 || months > 0) {
    throw new Error("don't use years or month which is not enough precise for second conversion");
  }

  return seconds + minutes * 60 + hours * 60 * 60 + days * 60 * 60 * 24 + weeks * 60 * 60 * 24 * 7;
}
